import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Modal } from "antd";
import Button from "../button";
import Icon from "../../assets/icons";
import { showToast } from "../toast";
import { RingLoader } from "react-spinners";
import StepIndicator from "./indicator";
import Input from "../input";
import useApi from "../hooks/request";
import { Controller } from "react-hook-form";
import Textarea from "../textarea";
import PurchaseOrderTable from "../../pages/purchase-order/details/items-table";


interface AddOrderNoteDialogProps {
    isVisible: boolean;
    onClose: () => void;
    purchase:  any
}

type FormStep = "NoteDetails" | "Summary";

const AddOrderNoteDialog: React.FC<AddOrderNoteDialogProps> = ({
    isVisible,
    onClose,
    purchase
}) => {
    const [currentStep, setCurrentStep] = useState<FormStep>(
        "NoteDetails"
    ); 
    
    const {
        handleSubmit,
        trigger,
        control,
        reset,
        formState: { errors },  
    } = useForm({
     mode: "onChange",
    });

    const { loading, makeRequest } = useApi(`/purchase-order/${purchase?._id}`, "PUT");

    const formatCurrency = (amount: any) => {
        return `₦${amount?.toLocaleString()}`;
     };
    const handleUpdateOrder =  handleSubmit(async (formData) => {
        
    
        const note = {
            transportationCost: formData.transportationCost,
            packagingCost: formData.packagingCost,
            miscCost: formData.miscCost,
            loadingPoint: formData.loadingPoint,
            deliveryPoint: formData.deliveryPoint,
            deliveryNote: formData.deliveryNote,
        }

        const payload = {note: note}
       
        
        const [response] = await makeRequest(payload);

        if (response.status) {
            showToast(response.message || "Order Note successfully", true, {
            position: "top-right",
            });
            onClose();
            reset();
            window.location.reload();
            
            
        } else {
            showToast(response?.message || "Failed to update order note", false, {
            position: "top-right",
            });
        }
    });

    const validateAndProceed = async () => {
        let isValid = true;

        if (currentStep === "NoteDetails") {
            const fieldsToValidate = [
                "transportationCost",
                "packagingCost",
                "miscCost",
                "loadingPoint",
                "deliveryPoint",
                "deliveryNote",
            ]
            isValid = await trigger(fieldsToValidate);
        } else if (currentStep === "Summary") {
            return handleUpdateOrder();
        }
        

        if (isValid) {
            if (currentStep === "NoteDetails") {
                setCurrentStep("Summary");
            }
        }

        
    }

    const goBackToPreviousStep = () => {
        if (currentStep === "Summary") {
            setCurrentStep("NoteDetails");
        }
    }

    const renderStepContent = () => {
        switch (currentStep) {
            case "NoteDetails":
                return (
                    <>
                        <div className="flex items-center mt-4 border rounded-full h-[48px] gap-5  border-[#9D9898]">
                            <div className=" ">
                                <div className="block text-sm">Transportation Cost</div>
                                <div className=" px-3 h-[45px] pt-2.5 mb-5 rounded-l-full text-center bg-gray-100">
                                    ₦
                                </div>
                            </div>
                            <div className="flex-1">
                                <Controller
                                    name="transportationCost"
                                    control={control}
                                    rules={{
                                    required: "Transport cost is required" 
                                    }}
                                    render={({ field, fieldState }) => (
                                    <input
                                        value={field.value || ""}
                                        className="w-full rounded-r-full outline-none h-[40px]"
                                        placeholder="Enter Transport Cost"
                                        onChange={field.onChange}
                                    />
                                    )}
                                />
                            </div>
                            <div className="w-20">
                            <span className="block text-sm">&nbsp;</span>
                            <select className="rounded-r-full h-[45px]  mb-5 bg-gray-100 px-3 w-full">
                                <option>Naira</option>
                            </select>
                            </div>
                        </div>
                        <div className="flex items-center mt-4 border rounded-full h-[48px] gap-5  border-[#9D9898]">
                            <div className=" ">
                                <div className="block text-sm">Packing Cost</div>
                                <div className=" px-3 h-[45px] pt-2.5 mb-5 rounded-l-full text-center bg-gray-100">
                                    ₦
                                </div>
                            </div>
                            <div className="flex-1">
                                <Controller
                                    name="packagingCost"
                                    control={control}
                                    // defaultValue={information?.price}
                                    rules={{
                                    required: "Packing cost is required" 
                                    }}
                                    render={({ field, fieldState }) => (
                                    <input
                                        value={field.value || ""}
                                        className="w-full rounded-r-full outline-none h-[40px]"
                                        placeholder="Enter Transport Cost"
                                    
                                        onChange={field.onChange}
                                    />
                                    )}
                                />
                            </div>
                            <div className="w-20">
                            <span className="block text-sm">&nbsp;</span>
                            <select className="rounded-r-full h-[45px]  mb-5 bg-gray-100 px-3 w-full">
                                <option>Naira</option>
                            </select>
                            </div>
                        </div>
                        <div className="flex items-center mt-4 border rounded-full h-[48px] gap-5  border-[#9D9898]">
                            <div className=" ">
                                <div className="block text-sm">Miscellaneous Cost</div>
                                <div className=" px-3 h-[45px] pt-2.5 mb-5 rounded-l-full text-center bg-gray-100">
                                    ₦
                                </div>
                            </div>
                            <div className="flex-1">
                                <Controller
                                    name="miscCost"
                                    control={control}
                                    // defaultValue={information?.price}
                                    rules={{
                                    required: "Miscellaneous cost is required" 
                                    }}
                                    render={({ field, fieldState }) => (
                                    <input
                                        value={field.value || ""}
                                        className="w-full rounded-r-full outline-none h-[40px]"
                                        placeholder="Enter Transport Cost"
                                    
                                        onChange={field.onChange}
                                    />
                                    )}
                                />
                            </div>
                            <div className="w-20">
                            <span className="block text-sm">&nbsp;</span>
                            <select className="rounded-r-full h-[45px]  mb-5 bg-gray-100 px-3 w-full">
                                <option>Naira</option>
                            </select>
                            </div>
                        </div>
                        <Controller
                            name="loadingPoint"
                            control={control}
                            rules={{
                            required: "Loading Point is required",
                            }}
                            render={({ field, fieldState }) => (
                            <Input
                                value={field.value}
                                className="w-full"
                                placeholder="Enter Loading Point "
                                error={fieldState?.error?.message}
                                onChange={field.onChange}
                                autoComplete="off"
                                label="Loading Point"
                            />
                            )}
                        />
                        <Controller
                            name="deliveryPoint"
                            control={control}
                            rules={{
                            required: "Delivery Point is required",
                            }}
                            render={({ field, fieldState }) => (
                            <Input
                                value={field.value}
                                className="w-full"
                                placeholder="Enter Delivery Point "
                                error={fieldState?.error?.message}
                                onChange={field.onChange}
                                autoComplete="off"
                                label="Delivery Point"
                            />
                            )}
                        />

                        <Controller
                                name="deliveryNote"
                                control={control}
                                rules={{
                                  required: "Note is required",
                                }}
                                render={({ field, fieldState }) => (
                                  <Textarea
                                    value={field.value}
                                    className="w-full"
                                    placeholder="Enter your main text here..."
                                    error={fieldState?.error?.message}
                                    onChange={field.onChange}
                                    label="Delivery Notes"
                                  />
                                )}
                              />
                       
                    </>
                );
            case "Summary":
                return (
                    <>
                        <PurchaseOrderTable data={purchase}/>
                         <div className="py-3 bg-white rounded-3xl shadow border w-full border-[#C9C9C9] pt-5 mt-7">
            <div className="">
              <div className="border-b pb-5 mt-5 px-5">
                <p className="text-[20px] font-bold">Final Total</p>
              </div>
              

              <div className="p-4 space-y-3 border-b pb-5 mt-5 px-5">
                <div className="flex justify-between items-center text-sm">
                  <span className="text-gray-600">Purchase Order Total</span>
                  <span className="font-medium">{formatCurrency(purchase?.note?.transportationCost)}</span>
                </div>

              </div>
              <div className="p-4 space-y-3 border-b pb-5 mt-5 px-5">
                <div className="flex justify-between items-center text-sm">
                  <span className="text-gray-600">Purchase Note Total</span>
                  <span className="font-medium">{formatCurrency(purchase?.note?.packagingCost)}</span>
                </div>

              </div>
              
              <div className=" space-y-3 mt-5 px-5">
                <div className="flex justify-between items-center text-sm">
                  <span className="text-gray-600">Total</span>
                  <span className="font-medium"> {formatCurrency(
                    (purchase?.note?.transportationCost || 0) + 
                    (purchase?.note?.packagingCost || 0) + 
                    (purchase?.note?.miscCost || 0)
                  )}</span>
                </div>

              </div>

            </div>
          </div>
                    </>
                );
            default:
                return null;
        }
    };

    const renderFooterButtons = () => {
        if (currentStep === "NoteDetails") {
            return (
                <div className="flex gap-3 py-2 mt-4">
                    <Button
                        type="button"
                        className="hover:bg-green-700 flex items-center"
                        onClick={validateAndProceed}
                        variant="primary"
                        size="lg"
                    >
                        <Icon name="noteIcon" />
                        Proceed to Summary
                    </Button>
                </div>
            )
        } else if (currentStep === "Summary") {
            return (
                <div className="flex gap-2 items-center text-center py-2 mt-4">
                    <button
                        type="button"
                        className="bg-[#E8F2E8] w-full rounded-full hover:bg-gray-200 px-7 py-2 text-[#047401] flex font-medium"
                        onClick={goBackToPreviousStep}
                    >
                        <Icon name="backIcon" />
                        Back to Order Note Details
                    </button>
                    <Button
                        type="submit"
                        variant="primary"
                        size="lg"
                        className="hover:bg-green-700 text-white flex items-center"
                        onClick={handleUpdateOrder}
                    >
                        {loading ? (
                        <RingLoader color="#ffffff" loading={loading} size={20} />
                        ) : (
                        <div className="flex gap-3">
                        Submit for Approval <Icon name="noteIcon" />
                        </div>
                        )}
                    </Button>
                </div>
            )
        }

        return null;
    }

    

    return ( 
        <Modal
            visible={isVisible}
            onCancel={onClose}
            width="80%"
                centered={true}
                footer={null}
                style={{
                padding: 0,
                margin: 0,
                maxWidth: "1200px",
                height: "auto",
            }}
        
        >
            <h1 className="text-2xl font-bold -mt-2 mb-4">Purchase Order Note</h1>
            <StepIndicator
                currentStep={currentStep}
                setCurrentStep={setCurrentStep}
            />
            <form onSubmit={handleUpdateOrder}>
                <div className="grid gap-4">{renderStepContent()}</div>
                {renderFooterButtons()}
            </form>

        </Modal>
    );
}
 
export default AddOrderNoteDialog;